import { MultiValue } from "react-select";
import Company from "./Company";
import CompanyCourse from "./CompanyCourse";
import User from "./IUser";
import { ISelectOption } from "./Select";

export type GenderType = "male" | "female";

export const GENDER_TYPES: ISelectOption<GenderType>[] = [
  {
    value: "female",
    label: "Femme",
  },
  {
    value: "male",
    label: "Homme",
  },
];

interface Person {
  id: string;
  gender: GenderType | null;
  authorId: string | null;
  companyId: string | null;
  firstname: string;
  lastname: string;
  fullname: string;
  email: string | null;
  phone: string | null;
  socialSecurityNumber: string | null;
  employmentStartDate: string | null;
  birthdate: string | null;
  cityOfBirth: string | null;
  jobTitle: string | null;
  contractType: string | null;
  isOwner: boolean;
  createdAt: string;
  updatedAt: string;
  author: User | null;
  company: Company | null;
  address: string | null;
  city: string | null;
  zipCode: string | null;
}

export interface PersonForm {
  address: string | null;
  city: string | null;
  zipCode: string | null;
  gender: ISelectOption<GenderType> | null;
  companyCourses: MultiValue<CompanyCourse>;
  firstname: string;
  lastname: string;
  companyId?: string | null;
  courseId?: string | null;
  email?: string | null;
  phone?: string | null;
  socialSecurityNumber?: string | null;
  employmentStartDate?: string | null;
  birthdate?: string | null;
  cityOfBirth?: string | null;
  jobTitle?: string | null;
  contractType?: string | null;
  isOwner?: boolean;
}

export interface PersonFormSend
  extends Omit<PersonForm, "gender" | "companyCourses"> {
  gender?: GenderType | null;
  companyCourseIds?: string[];
}

export default Person;
